import {
  FileStatus,
  ItemType,
  type Item,
  type SearchFile,
} from '@/shared/graphql/legacy/generated'
import { fileTypeToThumbnail } from '@/shared/utils/thumbnail'
import { applyAuthorizationToken } from '@/shared/utils/url'
import type { ThumbnailType } from '@dacr/library'

export const isItemInactive = (item: Item) =>
  item.file?.status === FileStatus.Inactive

export const itemDimClass = (item: Item) =>
  isItemInactive(item) ? 'opacity-50' : ''

export const itemThumbType = (item: Item): ThumbnailType =>
  item.type === ItemType.Folder
    ? 'folder'
    : fileTypeToThumbnail(item.file?.type)

export const itemThumbSrc = (item: Item) =>
  applyAuthorizationToken(item.file?.imageUrl, [{ key: 'width', value: 72 }])

export const fileThumbType = (file: SearchFile): ThumbnailType =>
  fileTypeToThumbnail(file.type)

export const fileThumbSrc = (file: SearchFile) =>
  applyAuthorizationToken(file.imageUrl, [{ key: 'width', value: 144 }])

export const formatPath = (path?: string | null) =>
  !path || path === '/' ? 'Dacr' : path
